t = require('views/internal/teacup-with-helpers')('board_menu_more')

module.exports = t.renderable ({ shortUrl, editableByMember, isLoggedIn, canCloseOrLeave, canCloseBoard, canLeaveBoard, pLevelAltText, pLevelClass, helperText, showCollections }) ->
  t.ul '.board-menu-navigation', ->

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-settings', { href: '#' }, ->
        t.icon 'gear', 'settings', { class: 'board-menu-navigation-item-link-icon' }

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-labels', { href: '#' }, ->
        t.icon 'label', 'labels', { class: 'board-menu-navigation-item-link-icon' }

    if showCollections
      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-collections', { href: '#' }, ->
          t.img '.board-menu-navigation-item-link-icon.collection-icon-img', { src: require('images/collections/collections-grey.svg') }
          t.raw '&nbsp;'
          t.format 'collections'

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-archive', { href: '#' }, ->
        t.icon 'archive', 'archived-items', { class: 'board-menu-navigation-item-link-icon' }

  t.hr()

  t.ul '.board-menu-navigation', ->

    if editableByMember
      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-email', { href: '#' }, ->
          t.icon 'email', 'email-to-board-settings', { class: 'board-menu-navigation-item-link-icon' }

    if isLoggedIn
      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-board-subscribe', { href: '#' }, ->
          t.icon 'subscribe', { class: 'board-menu-navigation-item-link-icon' }
          t.raw '&nbsp;'
          t.span '.js-subscribed-state'

      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-copy-board', { href: '#' }, ->
          t.icon 'board', 'copy-board', { class: 'board-menu-navigation-item-link-icon' }

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-share', { href: '#' }, ->
        t.icon 'share', 'print-and-export', { class: 'board-menu-navigation-item-link-icon' }

  if canCloseOrLeave

    t.hr()

    t.ul '.board-menu-navigation', ->

      if canCloseBoard
        t.li '.board-menu-navigation-item', ->
          t.a '.board-menu-navigation-item-link.js-close-board', { href: '#' }, ->
            t.raw '&nbsp;'
            t.format 'close-board-ellipsis'

      if canLeaveBoard
        t.li '.board-menu-navigation-item', ->
          t.a '.board-menu-navigation-item-link.js-leave-board', { href: '#' }, ->
            t.raw '&nbsp;'
            t.format 'leave-board-ellipsis'

  t.hr()

  t.form '.u-gutter', ->

    t.label { for: 'id-short-url' }, ->
      t.format 'link-to-this-board'

    t.input '.js-short-url', { type: 'text', readonly: 'readonly', id: 'id-short-url', value: shortUrl }

    t.p '.quiet', ->
      t.span { class: 'icon-sm icon-' + pLevelClass, title: pLevelAltText }
      t.text helperText



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_more.coffee